export default __webpack_public_path__ + "static/media/floaters-mid.bdeb943c.jpg";